import { createErrorReporter, createRpc, deviceId } from "@hachi/api";
import { auth, backendReady, store, supabaseConfig } from "./backend";

const rpc = createRpc({ auth, ...supabaseConfig });

const report = createErrorReporter({
  enabled: () => backendReady && !!auth.session(),
  send: (r) => rpc("report_client_error", { p_device: deviceId(store), p_message: r.message, p_stack: r.stack ?? null, p_route: r.route ?? location.hash.slice(0, 200), p_app: "web" }),
});

/** Sends errors the page throws to the admin's error list. Needs supabase/update-5-admin-health.sql; without it the reports quietly fail. */
export function watchErrors() {
  addEventListener("error", (e) => report(e.error ?? e.message));
  addEventListener("unhandledrejection", (e) => report(e.reason));
}
